import { render, staticRenderFns } from "./ConfigChannel.vue?vue&type=template&id=d834eb8e&scoped=true&"
import script from "./ConfigChannel.vue?vue&type=script&lang=ts&"
export * from "./ConfigChannel.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigChannel.vue?vue&type=style&index=0&id=d834eb8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d834eb8e",
  null
  
)

export default component.exports